<template>
  <div id="app">
    <div class="page">
      <div class="img-div">
        <img src="./img/qml-pay-1@2x.png" alt />
      </div>
      <div class="img-div">
        <img src="./img/qml-pay-2@2x.png" alt />
      </div>
      <div class="img-div">
        <img src="./img/qml-pay-3@2x.png" alt />
      </div>
      <div class="pay-text-div">
        <span>
          同步聊天记录适用于更换设备时使用
          <br />已经被删除的聊天记录无法同步
          <br />请了解清楚后进行购买
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";


export default {
  name: "app",
  data() {
    return {
      msg: "亲密聊支付页面"
    };
  },
  mounted(){
    this.$point.init(new Date());
    store.dispatch('hideLoading');   
  }

};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1334px;
  background: rgba(255, 255, 255, 1);
}

.img-div {
  width: 728px;
  height: 288px;
  margin: 20px auto 0;
}

.img-div img {
  width: 100%;
  height: 100%;
}

.pay-text-div {
  width: 100%;
  height: auto;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
  margin: 20px auto 0;

}
</style>


// WEBPACK FOOTER //
// src/components/app/qml/pay/pay.vue